"use client";

import { c as _c } from "react/compiler-runtime";
import { AltArrowDownLinear, AltArrowRightLinear } from "solar-icon-set";
import { Button } from "../Button";
import { Listbox, ListboxItem } from "../Listbox";
import { Popover, PopoverContent, PopoverTrigger } from "../Popover";
import { Tooltip } from "../Tooltip";
import { useUiLabels } from "../UiLabels/useUiLabels";
import type { BulkActionsDropdownProps } from "./BulkActionsDropdown.types";
const ITEM_CLASS = "flex w-full items-center justify-start rounded-small px-2 text-sm font-normal no-underline hover:no-underline data-[hover=true]:bg-default-100 data-[hover=true]:no-underline data-[hover=true]:opacity-100 aria-expanded:bg-default-100 aria-expanded:opacity-100";
export function BulkActionsDropdown(t0) {
  const $ = _c(27);
  const {
    selectedCount,
    selectedIds,
    actions
  } = t0;
  const uiLabels = useUiLabels();
  if (selectedCount === 0) {
    return null;
  }
  let t1;
  if ($[0] !== selectedCount) {
    t1 = action => {
      if (typeof action.label === "function") {
        return action.label(selectedCount);
      }
      return action.label;
    };
    $[0] = selectedCount;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const getActionLabel = t1;
  let t2;
  if ($[2] !== selectedCount || $[3] !== uiLabels.bulkActions) {
    t2 = uiLabels.bulkActions.selected(selectedCount);
    $[2] = selectedCount;
    $[3] = uiLabels.bulkActions;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t2) {
    t3 = <span className="text-default-800 text-sm">{t2}</span>;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <AltArrowDownLinear className="size-4" />;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== uiLabels.bulkActions.actions) {
    t5 = <PopoverTrigger><Button variant="light" color="primary" size="sm" className="rounded-none aria-expanded:border-b aria-expanded:border-b-border-interactive-primary-active aria-expanded:bg-transparent!" endContent={t4}>{uiLabels.bulkActions.actions}</Button></PopoverTrigger>;
    $[8] = uiLabels.bulkActions.actions;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== actions || $[11] !== getActionLabel || $[12] !== selectedIds || $[13] !== uiLabels.bulkActions.submenu) {
    let t7;
    if ($[15] !== getActionLabel || $[16] !== selectedIds || $[17] !== uiLabels.bulkActions.submenu) {
      t7 = action_0 => {
        const isDisabled = typeof action_0.isDisabled === "function" ? action_0.isDisabled(selectedIds) : action_0.isDisabled ?? false;
        if (action_0.subActions) {
          return <Popover key={action_0.key} placement="left-start" offset={20}><PopoverTrigger><Button role="menuitem" variant="light" size="sm" isDisabled={isDisabled} className={`${ITEM_CLASS} justify-between`} startContent={action_0.icon} endContent={<AltArrowRightLinear className="size-4 text-default-400" />}>{getActionLabel(action_0)}</Button></PopoverTrigger><PopoverContent className="p-0"><Listbox aria-label={typeof action_0.label === "string" ? action_0.label : uiLabels.bulkActions.submenu} className="min-w-[200px]" itemClasses={{
                title: "text-sm"
              }}>{action_0.subActions.map(sub => <ListboxItem key={sub.key} onPress={() => sub.onAction(selectedIds)}>{sub.label}</ListboxItem>)}</Listbox></PopoverContent></Popover>;
        }
        return <Tooltip key={action_0.key} content={action_0.disabledTooltip ?? ""} isDisabled={!isDisabled || !action_0.disabledTooltip}><Button role="menuitem" variant="light" size="sm" isDisabled={isDisabled} className={`${ITEM_CLASS} ${action_0.color === "danger" ? "text-danger" : ""}`} startContent={action_0.icon} onPress={() => action_0.onAction(selectedIds)}>{getActionLabel(action_0)}</Button></Tooltip>;
      };
      $[15] = getActionLabel;
      $[16] = selectedIds;
      $[17] = uiLabels.bulkActions.submenu;
      $[18] = t7;
    } else {
      t7 = $[18];
    }
    t6 = actions.map(t7);
    $[10] = actions;
    $[11] = getActionLabel;
    $[12] = selectedIds;
    $[13] = uiLabels.bulkActions.submenu;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[19] !== t6) {
    t7 = <PopoverContent className="p-0"><div role="menu" className="flex min-w-40 flex-col p-1">{t6}</div></PopoverContent>;
    $[19] = t6;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  let t8;
  if ($[21] !== t5 || $[22] !== t7) {
    t8 = <Popover placement="bottom-end">{t5}{t7}</Popover>;
    $[21] = t5;
    $[22] = t7;
    $[23] = t8;
  } else {
    t8 = $[23];
  }
  let t9;
  if ($[24] !== t3 || $[25] !== t8) {
    t9 = <div className="flex items-center gap-2">{t3}{t8}</div>;
    $[24] = t3;
    $[25] = t8;
    $[26] = t9;
  } else {
    t9 = $[26];
  }
  return t9;
}